import { motion } from "framer-motion";
import { Fragment, useMemo, useState } from "react";

import { HiChevronLeft } from "react-icons/hi";

import { animatePage } from "../../animateConstant";
import CloseComponent from "../../components/CloseComponent/CloseComponent";
import { Button } from "semantic-ui-react";
import InputCustom from "../../components/InputComponents/InputCustom";
import { Base64 } from "js-base64";
import { REPLACE_UNDERSCORE_TO_AIR } from "../../replace_str_constant";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { notice } from "../../redux/action/action";
import CommonProgress from "../../components/CommonProgress/CommonProgress";
import GetParams from "../../utils/getParams";
import { useNavigate } from "react-router";
import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";

const WithdrawStepTwo = ({
  withdrawStep,
  setWithdrawStep,
  chooseCurrency,
  withdrawData,
}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`withdraw.${key}`);

  const dispatch = useDispatch();
  const memberData = useSelector((state) => state.isMemberInfo);

  const navigate = useNavigate();

  const [data, setData] = useState({});
  const [dataFocus, setDataFocus] = useState({});
  const [buttonLoading, setButtonLoading] = useState(false);

  const base64Option = Base64?.decode(withdrawData?.option);
  const jsonParseOption = JSON.parse(base64Option);

  const nowMethod = GetParams("method");

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const handleFocus = (e) => {
    setDataFocus({ [e.target.name]: true });
  };

  const handleSubmit = () => {
    // withdrawCollect({
    //   payway3: { payway3: nowMethod, ...data },
    //   amounts: data.amounts,
    // })
    //   .then((data) => {
    //     if (data.code === "Ok") {
    //       dispatch(notice(data.msg, "success"));
    //       navigate("/");
    //     } else {
    //       dispatch(notice(data.msg, "error"));
    //     }
    //   })
    //   .finally(() => {
    //     setButtonLoading(false);
    //   });
  };

  const diabledButton = useMemo(() => {
    return Object.keys(data).length !== jsonParseOption.length + 1;
  }, [data]);

  return (
    <motion.section
      className="h-full flex flex-col gap-[10px] "
      layout
      initial={withdrawStep === 1 ? "hiddenRight" : "hiddenLeft"}
      animate="visible"
      exit={withdrawStep === 1 ? "hiddenRight" : "hiddenLeft"}
      variants={animatePage}
    >
      <section>
        <CloseDetailPage
          hasPrev={
            <HiChevronLeft
              className="cursor-pointer"
              onClick={() => setWithdrawStep(1)}
            />
          }
          title={nowMethod.toUpperCase()}
        />

        <div className="flex items-center justify-center mb-[30px]">
          <img
            src={`https://cityofwins.com/PayWay/bankIcon/${nowMethod?.toLowerCase()}.png`}
            className="w-[50px] object-contain"
            alt="bankIcon"
          />
        </div>

        <section>
          <p className="text-center text-transaction-text my-[20px]">
            {i18n("enterdetail")}
          </p>

          <p className="text-xl font-extrabold text-main-color">
            {i18n("withdraw")}
            {chooseCurrency}
          </p>
          <section>
            <section className="mb-[24px]">
              {jsonParseOption.map((item, index) => {
                const type = (type) => {
                  switch (type) {
                    case "string":
                      return "text";
                    case "int":
                      return "number";
                    case "select":
                      return "select";
                    default:
                      return "text";
                  }
                };
                return (
                  <Fragment key={index}>
                    <p className="mb-[5px] text-light-white font-semibold">
                      {REPLACE_UNDERSCORE_TO_AIR(item.name)}
                    </p>
                    <InputCustom
                      placeholder={`Enter your ${REPLACE_UNDERSCORE_TO_AIR(
                        item.name
                      )}`}
                      options={item.option}
                      type={type(item.type)}
                      name={item.name}
                      setDataProps={setData}
                      dataProps={data}
                      onChange={item.type === "select" ? null : handleChange}
                      onFocus={(e) => handleFocus(e)}
                      focusProps={dataFocus}
                    />
                  </Fragment>
                );
              })}
              <p className="mb-[5px] text-light-white font-semibold">
                Withdrawl amount
              </p>

              <InputCustom
                placeholder={`Enter your ${chooseCurrency} amounts`}
                type="text"
                name="amounts"
                setDataProps={setData}
                dataProps={data}
                onChange={(e) => handleChange(e)}
                onFocus={(e) => handleFocus(e)}
                focusProps={dataFocus}
              />
            </section>
          </section>
          <section className="mb-[10px]"></section>
        </section>
      </section>
      <section>
        {memberData?.washCheck > 0 && (
          <div className="mb-[10px]">
            <p className="mb-[5px] text-gold-text">{i18n("wagerNotice")}：</p>
            <CommonProgress
              firstValue={memberData?.total_bet}
              secondValue={memberData?.washCheck}
            />
          </div>
        )}
        {data.amounts && (
          <p className="text-transaction-text">
            {chooseCurrency}{" "}
            <span className="text-main-color font-bold">{data.amounts}</span> In
            your personal account
          </p>
        )}
        <Button
          loading={buttonLoading}
          disabled={diabledButton || buttonLoading}
          className="!bg-main-color !text-white w-full"
          content={i18n("withdraw")}
          onClick={() => handleSubmit()}
          size="big"
        />
      </section>
    </motion.section>
  );
};

export default WithdrawStepTwo;
